<template>
  <section
    ref="section13"
    :class="[(Object.keys(validationErrors).length > 0 ? 'has-errors' : ''), 'mx-auto flex h-full flex-col']"
  >
    <v-add-listing-head
      :routes="routes"
      :step="14"
    ></v-add-listing-head>
    <main
      class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
    >
      <figure class="relative flex max-w-3xl flex-col gap-11 lg:w-full">
        <figure class="ml-auto mr-auto flex w-full max-w-lg gap-3">
          <div><v-icon icon="build-circle" size="8"></v-icon></div>
          <div class="flex flex-col justify-center">
            <div class="mr-6 text-heading-3-desktop">
              Je bila vaša nepremičnina prenovljena?
            </div>
          </div>

          <v-lightbox is-authenticated footerless>
            <template v-slot:trigger>
                <div
                    class="absolute right-0 top-0 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-green-25"
                >
                    <v-icon icon="question-mark" size="4"></v-icon>
                </div>
            </template>
            <template v-slot:head>
                <div class="flex items-start">
                    <v-icon
                        icon="question-mark"
                        class="mr-2.5"
                        size="4.5"
                    ></v-icon>
                    <div>
                        Dodatne informacije
                    </div>
                </div>
            </template>
            <template v-slot:content>
                <p class="mb-[10px] text-icon-text-medium">
                    Prenova nepremičnine
                </p>
                <p class="mb-8 text-body-regular">
                    Vnesite ali je bila vaša nepremičnina v zadnjih časih (obdobje približno 5. letih) prenovljena ali ne. Pri vsaki možnosti prenov so tudi opisi, ki podrobneje razložijo pomen vsakega tipa prenove.
                </p>
            </template>
          </v-lightbox>
        </figure>
        <figure class="ml-auto mr-auto w-full max-w-3xl">
          <form method="POST" :action="routes.submitForm" id="select-property-renovations">
            <v-csrf-token></v-csrf-token>
            <figure>
              <figure
                class="ml-auto mr-auto grid w-full max-w-3xl grid-cols-2 grid-rows-1 gap-4 lg:flex lg:grid-cols-2 lg:flex-wrap lg:justify-center lg:gap-6"
              >
                <div
                  name="jeBilaVasaNepremicninaPrenovljenaDa"
                  :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.renovation_status ? 'has-errors' : '')]"
                >
                  <input
                    type="radio"
                    id="jeBilaVasaNepremicninaPrenovljenaDa"
                    name="renovation_status"
                    value="1"
                    class="hidden"
                    v-model="renovated"
                    @change="status = null"
                  />
                  <label
                    for="jeBilaVasaNepremicninaPrenovljenaDa"
                    class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                  >
                    <v-icon icon="circle-check" size="5"></v-icon>
                    <span class="pointer-events-none select-none">Da</span>
                  </label>
                </div>
                <div
                  name="jeBilaVasaNepremicninaPrenovljenaNe"
                  :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.renovation_status ? 'has-errors' : '')]"
                >
                  <input
                    type="radio"
                    id="jeBilaVasaNepremicninaPrenovljenaNe"
                    name="renovation_status"
                    value="0"
                    class="hidden"
                    v-model="renovated"
                    @change="status = null"
                  />
                  <label
                    for="jeBilaVasaNepremicninaPrenovljenaNe"
                    class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                  >
                    <v-icon icon="cancel" size="5"></v-icon>
                    <span class="pointer-events-none select-none">Ne</span>
                  </label>
                </div>
              </figure>
              <figure
                v-if="renovated != null"
                class="mb-4 mt-8 flex w-full items-center justify-center gap-[10px] text-body-medium-button text-black-78"
              >
                <v-icon icon="house-work"></v-icon>
                <span> Trenutno stanje nepremičnine <sup>*</sup> </span>
              </figure>
              <figure
                class="ml-auto mr-auto grid w-full max-w-3xl grid-cols-1 gap-x-6 gap-y-[10px] lg:grid-cols-2 lg:gap-6"
              >
                <template v-if="renovated == 1">
                  <div
                    name="stanjeNepremicnine-delnaPrenova"
                    :class="['tile group relative w-full flex-col sm:flex-row', (validationErrors.zustand ? 'has-errors' : '')]"
                  >
                    <input
                      type="radio"
                      name="zustand"
                      id="stanjeNepremicnine-delnaPrenova"
                      value="modernisiert"
                      class="hidden"
                      v-model="status"
                    />

                    <label
                      for="stanjeNepremicnine-delnaPrenova"
                      class="flex cursor-pointer flex-col gap-[10px] rounded-xl bg-white p-4 px-8 py-11 py-6 text-body-medium-button text-black-78 shadow transition-all"
                    >
                      <div class="flex gap-3">
                        <v-icon icon="power-drill" size="6"></v-icon>
                        <span
                          class="pointer-events-none select-none text-heading-4-medium"
                          >Delna prenova</span
                        >
                      </div>
                      <div class="text-body-regular text-black-40">
                        Nepremičnina je prenovljena po delih npr. prebarvane stene,
                        nova kuhinja, itd.
                      </div>
                    </label>
                  </div>
                  <div
                    name="stanjeNepremicnine-celostnaSanacija"
                    :class="['tile group relative w-full flex-col sm:flex-row', (validationErrors.zustand ? 'has-errors' : '')]"
                  >
                    <input
                      type="radio"
                      name="zustand"
                      id="stanjeNepremicnine-celostnaSanacija"
                      value="saniert"
                      class="hidden"
                      v-model="status"
                    />

                    <label
                      for="stanjeNepremicnine-celostnaSanacija"
                      class="flex cursor-pointer flex-col gap-[10px] rounded-xl bg-white p-4 px-8 py-11 py-6 text-body-medium-button text-black-78 shadow transition-all"
                    >
                      <div class="flex gap-3">
                        <v-icon icon="reset-wrench" size="6"></v-icon>
                        <span
                          class="pointer-events-none select-none text-heading-4-medium"
                          >Celostna sanacija</span
                        >
                      </div>
                      <div class="text-body-regular text-black-40">
                        Nepremičnina je bila v celoti sanirana / adaptirana.
                      </div>
                    </label>
                  </div>
                </template>
                <template v-if="renovated == 0">
                  <div
                    name="stanjeNepremicnine-prvaVselitev"
                    :class="['tile group relative w-full flex-col sm:flex-row', (validationErrors.zustand ? 'has-errors' : '')]"
                  >
                    <input
                      type="radio"
                      name="zustand"
                      id="stanjeNepremicnine-prvaVselitev"
                      value="erstbezug_nach_sanierung"
                      class="hidden"
                      v-model="status"
                    />

                    <label
                      for="stanjeNepremicnine-prvaVselitev"
                      class="flex cursor-pointer flex-col gap-[10px] rounded-xl bg-white p-4 px-8 py-11 py-6 text-body-medium-button text-black-78 shadow transition-all"
                    >
                      <div class="flex gap-3">
                        <v-icon icon="house-user" size="6"></v-icon>
                        <span
                          class="pointer-events-none select-none text-heading-4-medium"
                          >Prva vselitev</span
                        >
                      </div>
                      <div class="text-body-regular text-black-40">
                        Nepremičnina je na novo izgrajena ali popolnoma sanirana in
                        bo prvič vseljena.
                      </div>
                    </label>
                  </div>
                  <div
                    name="stanjeNepremicnine-kotNova"
                    :class="['tile group relative w-full flex-col sm:flex-row', (validationErrors.zustand ? 'has-errors' : '')]"
                  >
                    <input
                      type="radio"
                      name="zustand"
                      id="stanjeNepremicnine-kotNova"
                      value="neuwertig"
                      class="hidden"
                      v-model="status"
                    />

                    <label
                      for="stanjeNepremicnine-kotNova"
                      class="flex cursor-pointer flex-col gap-[10px] rounded-xl bg-white p-4 px-8 py-11 py-6 text-body-medium-button text-black-78 shadow transition-all"
                    >
                      <div class="flex gap-3">
                        <v-icon icon="ambient-screen" size="6"></v-icon>
                        <span
                          class="pointer-events-none select-none text-heading-4-medium"
                          >Kot nova</span
                        >
                      </div>
                      <div class="text-body-regular text-black-40">
                        Nepremičnina je v brezihbnem stanju in ne potrebuje prenov
                        ali sanacij.
                      </div>
                    </label>
                  </div>
                  <div
                    name="stanjeNepremicnine-dobroOhranjena"
                    :class="['tile group relative w-full flex-col sm:flex-row', (validationErrors.zustand ? 'has-errors' : '')]"
                  >
                    <input
                      type="radio"
                      name="zustand"
                      id="stanjeNepremicnine-dobroOhranjena"
                      value="gepflegt"
                      class="hidden"
                      v-model="status"
                    />

                    <label
                      for="stanjeNepremicnine-dobroOhranjena"
                      class="flex cursor-pointer flex-col gap-[10px] rounded-xl bg-white p-4 px-8 py-11 py-6 text-body-medium-button text-black-78 shadow transition-all"
                    >
                      <div class="flex gap-3">
                        <v-icon icon="bookmark-added" size="6"></v-icon>
                        <span
                          class="pointer-events-none select-none text-heading-4-medium"
                          >Dobro ohranjena</span
                        >
                      </div>
                      <div class="text-body-regular text-black-40">
                        Nepremičnina je dobro ohranjena in potrebuje zgolj manjše
                        sanacije.
                      </div>
                    </label>
                  </div>
                  <div
                    name="stanjeNepremicnine-potrebujePrenovo"
                    :class="['tile group relative w-full flex-col sm:flex-row', (validationErrors.zustand ? 'has-errors' : '')]"
                  >
                    <input
                      type="radio"
                      name="zustand"
                      id="stanjeNepremicnine-potrebujePrenovo"
                      value="renovierungsbeduerftig"
                      class="hidden"
                      v-model="status"
                    />

                    <label
                      for="stanjeNepremicnine-potrebujePrenovo"
                      class="flex cursor-pointer flex-col gap-[10px] rounded-xl bg-white p-4 px-8 py-11 py-6 text-body-medium-button text-black-78 shadow transition-all"
                    >
                      <div class="flex gap-3">
                        <v-icon icon="handyman" size="6"></v-icon>
                        <span
                          class="pointer-events-none select-none text-heading-4-medium"
                          >Potrebuje prenovo</span
                        >
                      </div>
                      <div class="text-body-regular text-black-40">
                        Nepremičnina je v slabem stanju in nujno potrebno prenovo.
                      </div>
                    </label>
                  </div>
                </template>
              </figure>
            </figure>
          </form>
        </figure>
      </figure>
    </main>
    <v-add-listing-foot>
      <a
        @click="submitForm('select-property-renovations')"
        :class="['button button--md h-[48px] w-[240px] px-6', (validated ? '' : 'button button--gray')]"
      >
        <label class="text-small-text-medium">Nadaljujte</label>
        <v-icon icon="arrow-right" size="4"></v-icon>
      </a>
    </v-add-listing-foot>
  </section>
</template>
<script>
import AddListingFootVue from '../AddListingFoot.vue';
import AddListingHeadVue from '../AddListingHead.vue';

export default {
  components: {
    "v-add-listing-foot": AddListingFootVue,
    "v-add-listing-head": AddListingHeadVue,
  },
  props: {
    old: {
      type: Object,
      required: false,
      default: {},
    },
    routes: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
      default: {},
    },
    stepData: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data() {
    return {
      renovated: null,
      status: null,
    };
  },
  mounted() {
    this.renovated = (this.old.renovation_status ? this.old.renovation_status : (this.stepData.renovation_status != null ? Number(this.stepData.renovation_status) : null))
    this.status = (this.old.zustand ? this.old.zustand : this.stepData.zustand)
  },
  computed: {
    renovatedCasted() {
      return this.renovated ? 1 : 0;
    },
    validated() {
      if(this.renovated == null || this.status == null) return false
      
      return true;
    }
  },
  methods: {
    submitForm(formId) {
      if(this.validated) document.getElementById(formId).submit();
    },
  },
};
</script>